import {ThreeGaussianSplatPlugin} from './three-gaussian-splat'

export class GaussianSplattingPlugin extends ThreeGaussianSplatPlugin {}

export * as threeGaussianSplat from './three-gaussian-splat'
